<script setup>
import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据
import { Message } from '@arco-design/web-vue'
import Swiper from 'swiper'
import {
    EffectFade,
    Pagination,
    Autoplay,
    Parallax,
    Keyboard,
    Navigation  // 添加Navigation模块
} from 'swiper/modules'

import { getAllContent, requestThemeContent, getRecommend, getFunction, getApplicationScenarios, getCustomerVoice, getComparison, getQuickStart } from '/api/theServer.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

import HzQuickjump from '@/components/main/HzQuickjump.vue'



const HeziyunData = ref(parseHeziyunData().global)

console.log(HeziyunData.value)
// 初始化 Swiper
const initSwiper = () => {
    nextTick(() => {
        new Swiper('.swiper-container', {
            modules: [Pagination, Navigation], // 注册使用的模块
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 100
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 100
                }
            }
        })
    })
}

// 无缝滚动 重复代码
const cloneElementsOptimized = () => {
    const elements = document.querySelectorAll('.Heziyun-repeat[data-quantity]')

    if (!elements || elements.length === 0) return

    elements.forEach((original) => {
        // 4. 获取克隆次数（限制最大值，防止性能问题）
        const quantity = Math.min(
            parseInt(original.getAttribute('data-quantity')) || 0,
            2 // 安全限制，最多克隆 2 次
        )

        // 5. 如果不需要克隆，跳过
        if (quantity <= 0) return

        // 6. 使用 DocumentFragment 批量插入（减少 DOM 操作）
        const fragment = document.createDocumentFragment()

        // 7. 循环克隆并添加到 fragment
        for (let i = 0; i < quantity; i++) {
            const clone = original.cloneNode(true) // 深度克隆
            fragment.appendChild(clone)
        }

        // 8. 一次性插入到 DOM（减少重排）
        original.parentNode.insertBefore(fragment, original.nextSibling)
    })
}
const applyRandomBgToItems = () => {
    const items = document.querySelectorAll('.Heziyun-repeat .Heziyun-item')
    const usedColors = new Set() // 用于记录已使用的颜色

    items.forEach(item => {
        let color
        let attempts = 0
        const maxAttempts = 100 // 防止无限循环

        // 确保生成的颜色是唯一的
        do {
            color = getRandomLightColor()
            attempts++
        } while (usedColors.has(color) && attempts < maxAttempts)

        usedColors.add(color)
        item.style.backgroundColor = color
        item.style.color = '#000' // 强制文字为黑色
    })
}

// 生成明亮且多样的浅色
const getRandomLightColor = () => {
    // 使用HSL颜色模型，更容易控制亮度和饱和度
    const hue = Math.floor(Math.random() * 360) // 全色相范围
    const saturation = 30 + Math.floor(Math.random() * 40) // 饱和度30-70%
    const lightness = 85 + Math.floor(Math.random() * 15) // 亮度85-100%
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}


// 快捷跳转
const quickJump = ref([
    { id: 1, name: t('product.quickJump.advantages'), target: 'Heziyun-advantage' },
    { id: 2, name: t('product.quickJump.features'), target: 'Heziyun-function' },
    { id: 3, name: t('product.quickJump.applicationScenarios'), target: 'Heziyun-applicationScenarios' },
    { id: 4, name: t('product.quickJump.customerVoice'), target: 'Heziyun-custome' },
    { id: 5, name: t('product.quickJump.productComparison'), target: 'Heziyun-characteristics' },
    { id: 6, name: t('product.quickJump.quickStart'), target: 'Heziyun-quickStart' },
])

const mainBodyes = ref([]) // 全部主体内容
const mainBody = ref([]) // 主体内容
const recommend = ref([]) // 获取介绍页产品推荐
const productFeatures = ref([]) // 获取产品功能
const productComparison = ref([]) // 应用场景
const customerVoice = ref([]) // 获取客户之声
const contrast = ref([]) // 产品对比
const quickStart = ref([]) // 快速入门

// 获取地址链接
const getCurrentPageName = () => {
    // 获取当前页面的完整路径
    const currentPath = window.location.pathname

    // 提取文件名
    const fileNameWithExt = currentPath.split('/').pop()

    // 移除扩展名
    if (fileNameWithExt.includes('.')) {
        return fileNameWithExt.substring(0, fileNameWithExt.lastIndexOf('.'))
    }
    return fileNameWithExt
}
// 使用示例
const currentFileName = getCurrentPageName()
// 并发请求所有数据
const fetchAllData = async () => {

    try {
        const [
            allContentRes,
            themeContentRes,
            recommendRes,
            functionRes,
            applicationScenariosRes,
            customerVoiceRes,
            comparisonRes,
            quickStartRes
        ] = await Promise.all([
            getAllContent({ limit: 10 }),
            requestThemeContent({ limit: 50, address: currentFileName }),
            getRecommend({ limit: 50, address: currentFileName }),
            getFunction({ limit: 50, address: currentFileName }),
            getApplicationScenarios({ limit: 50, address: currentFileName }),
            getCustomerVoice({ limit: 50, address: currentFileName }),
            getComparison({ limit: 50, address: currentFileName }),
            getQuickStart({ limit: 50, address: currentFileName })
        ])
        
        
        // 处理响应数据
        mainBodyes.value = allContentRes.data.list.slice(0, 2)
        mainBody.value = themeContentRes.data.list[0]
        recommend.value = recommendRes.data.list
        productFeatures.value = functionRes.data
        productComparison.value = applicationScenariosRes.data.list
        contrast.value = comparisonRes.data.list
        quickStart.value = quickStartRes.data.list

        // 处理客户之声数据分组
        const list = customerVoiceRes.data.list
        const groupedItems = list.reduce((result, item, index) => {
            const groupIndex = Math.floor(index / 7)
            if (!result[groupIndex]) {
                result[groupIndex] = []
            }
            result[groupIndex].push(item)
            return result
        }, [])
        customerVoice.value = groupedItems

        // 初始化轮播和DOM操作
        nextTick(() => {
            initSwiper()
            cloneElementsOptimized()
            applyRandomBgToItems()
        })

    } catch (error) {
        console.error('数据请求失败:', error)
        // 可以根据需要添加错误处理，如显示错误提示
        Message.error('数据加载失败，请稍后重试')
    }
}

// 获取当前域名
const getDomain = () => {
    const baseUrl = window.location.origin
    return baseUrl
}

onBeforeMount(() => {

    fetchAllData() // 并发请求所有板块数据
})

</script>

<template>
    <!-- banner图 -->
    <div class="Heziyun-banners" :style="{ background: `url(${getDomain()}${mainBody?.banner}) no-repeat center` }">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-banner-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }" v-show="mainBody.title">{{
                    mainBody.title }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }" v-show="mainBody.tips">{{
                    mainBody.tips }}</p>
                <div class="Heziyun-buttonArray">
                    <a class="Heziyun-lightSpeed" :href="mainBody.btn_url" v-show="mainBody.btn_name"
                        v-intersect="{ class: 'bottom-top', delay: 200 }">{{ mainBody.btn_name }}</a>
                    <a href="/home.htm" v-show="mainBody.btn_name" v-intersect="{ class: 'bottom-top', delay: 200 }">{{
                        $t('product.console')
                        }}</a>
                </div>

                <div class="Heziyun-suitableRegion" v-intersect="{ class: 'bottom-top', delay: 400 }"
                    v-show="mainBody.region">
                    <img src="@/static/img/theServer/3.gif" alt="">
                    {{ $t('product.suitableRegion') }}：{{ mainBody.region }}
                </div>

                <div class="Heziyun-recommendedServices">
                    <a :href="`/server/` + item.file + `.html`" class="Heziyun-item Heziyun-lightSpeed"
                        v-for="(item, index) in mainBodyes"
                        v-intersect="{ class: 'right-left', delay: (index + 1) * 50 }">
                        <div class="Heziyun-title">{{ item.title }}</div>
                        <div class="Heziyun-describe">{{ item.tips }}</div>
                    </a>
                </div>
            </div>
        </div>
    </div>


    <HzQuickjump :quickjump="quickJump"></HzQuickjump>


    <!-- 产品优势---------------------------------------------------------------------------------------- -->
    <div class="Heziyun-advantage Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span>{{ $t('product.advantages') }}</span>
                <p></p>
            </div>
            <div class="Heziyun-content">
                <div class="Heziyun-item" v-for="(item, index) in recommend">
                    <div class="Heziyun-titleImg">
                        <img :src="item.ico" alt="">
                        <span>{{ item.title }}</span>
                    </div>
                    <p>{{ item.content }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 产品功能---------------------------------------------------------------------------------------- -->
    <div class="Heziyun-function Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span>{{ $t('product.features') }}</span>
                <p></p>
            </div>
            <div class="Heziyun-content">
                <div class="Heziyun-item" v-for="(item, index) in productFeatures" :key="item.id">
                    <div class="Heziyun-title">{{ item.title }}</div>
                    <div class="Heziyun-Qte" v-for="itemes in item.item" :key="itemes.id">
                        <span>
                            <img :src="itemes.ico" alt="">
                            {{ itemes.title }}
                        </span>
                        <p>{{ itemes.content }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 应用场景---------------------------------------------------------------------------------------- -->
    <div class="Heziyun-applicationScenarios Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span>{{ $t('product.applicationScenarios') }}</span>
                <p></p>
            </div>
            <div class="Heziyun-content">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in productComparison" :key="item.id">
                            <img :src="item.ico" alt="">
                            <span class="Heziyun-textOverflow">{{ item.title }}</span>
                            <p>{{ item.content }}</p>
                        </div>
                    </div>
                </div>

                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
    </div>

    <!-- 客户之声---------------------------------------------------------------------------------------- -->
    <div class="Heziyun-custome Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span>{{ $t('product.customerVoice') }}</span>
                <p></p>
            </div>
        </div>
        <!-- 无缝滚动 -->
        <div class="partners-section">
            <div class="partners-track" v-for="(item, index) in customerVoice" :style="`--t:${25 + index * 5}s`">
                <!-- 实际区域 -->
                <div class="Heziyun-repeat" data-quantity="1">
                    <a class="Heziyun-item" target="_blank" v-for="items in item">{{ items.message
                    }}</a>
                </div>
            </div>
        </div>
    </div>

    <!-- 产品对比---------------------------------------------------------------------------------------- -->
    <div class="Heziyun-characteristics ">
        <div class="Heziyun-padding">
            <div class="Heziyun-defaultWidth">
                <div class="Heziyun-commodity-title">
                    <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{
                        $t('product.productComparison') }}</span>
                    <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{
                        $t('product.comparisonSubtitle') }}</p>
                </div>
                <div class="Heziyun-melt">
                    <table v-intersect="{ class: 'bottom-top', delay: 100 }">
                        <colgroup>
                            <col style="width: 20%;">
                            <col style="width: 40%;">
                            <col style="width: 40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>{{ $t('product.comparisonItem') }}</th>
                                <th>{{ $t('product.otherVendors') }}</th>
                                <th
                                    style="background: #2c6bff;border-radius: 0 4px 0 0;color: #fff;border-top: 2px solid #2c6bff;">
                                    <img src="@/static/img/cpsExtension/logo-private.svg" alt="">{{
                                        HeziyunData?.webname }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in contrast">
                                <td>{{ item.item }}</td>
                                <td>{{ item.other }}</td>
                                <td>{{ item.my }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- 快速入门---------------------------------------------------------------------------------------- -->
    <div class="Heziyun-quickStart Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span>{{ $t('product.quickStart') }}</span>
                <p></p>
            </div>
            <div class="Heziyun-content">
                <a :href="item.url" class="Heziyun-item" v-for="(item, index) in quickStart">
                    <div class="Heziyun-title">{{ index + 1 < 10 ? '0' + (index + 1) : index + 1 }}<i>
                            </i></div>
                    <div class="Heziyun-text">
                        <span>{{ item.title }}</span>
                        <p>{{ item.content }}</p>
                    </div>
                </a>
            </div>
        </div>
    </div>

</template>

<style>
@import "@/static/css/import";
@import "@/static/font/font.css";
@import 'swiper/css';
@import 'swiper/css/effect-fade';
@import 'swiper/css/pagination';

body {
    background-color: #f5f7fc;
}

.swiper-navigation-icon {
    display: none;
}
</style>

<style lang="less" scoped>
body {
    background-color: rgb(242, 245, 249);
}

@font-face {
    font-family: "din";
    font-weight: 400;
    src: url("../../static/font/file/DINCond-Bold.woff") format("woff2");
    font-display: swap;
}

// banner图
.Heziyun-banners {
    background: url('../../static/img/theServer/banner.png') no-repeat center;
    background-size: cover;
    position: relative;
    height: 25rem;
    padding: 0;
    margin-top: 3.6rem;

    .Heziyun-defaultWidth {
        position: relative;
        z-index: 2;
        height: 100%;

        .Heziyun-banner-title {
            position: relative;

            span {
                font-weight: 500;
            }

            p {
                text-align: left;
                color: #d6d6d6;
            }

            .Heziyun-buttonArray {
                display: flex;
                align-items: center;
                gap: 0.5rem;

                a {
                    background-color: #216df0;
                    color: #fff;
                    border: 1.5px solid #216df0;
                    box-shadow: 0px 12px 40px rgb(42 105 255 / 61%);
                    min-width: 7rem;
                    text-align: center;
                    padding: 0.5rem 1.5rem;

                    &:hover {
                        opacity: 0.75;
                    }
                }

                a:nth-of-type(2) {
                    box-shadow: 8px 8px 20px rgba(55, 99, 170, .1);
                    color: #0052d9;
                    background-color: #fff;
                    border: 1px solid #fff;

                    &:hover {
                        box-shadow: 8px 8px 20px rgba(55, 99, 170, .1);
                        background-color: #ecf2fe;
                        border: 1px solid #0052d9;
                        opacity: 1;
                    }
                }
            }

            .Heziyun-suitableRegion {
                color: initial;
                position: absolute;
                bottom: 2rem;
                left: 0;
                font-size: 0.79rem;
                color: #fff;

                img {
                    width: 1rem;
                    object-fit: contain;
                }
            }

            .Heziyun-recommendedServices {
                position: absolute;
                bottom: 2rem;
                right: 0;
                display: flex;
                flex-direction: column;
                gap: 1rem;

                .Heziyun-item {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                    padding: 0.6rem 1rem;
                    background: linear-gradient(270deg, rgb(61 67 87) 0%, rgba(34, 36, 41, 1) 100%);

                    &:hover {
                        background: linear-gradient(270deg, rgb(61, 67, 87) 0%, rgb(61, 67, 87) 0%);
                    }

                    .Heziyun-title {
                        color: #fff;
                    }

                    .Heziyun-describe {
                        color: #5896ff;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        width: 300px;
                    }
                }
            }
        }
    }

}

@media (max-width: 768px) {

    // banner图
    .Heziyun-banners {
        height: 90vw;
        margin-top: 15vw;

        .Heziyun-defaultWidth {

            .Heziyun-banner-title {
                align-items: center;
                padding-bottom: 25vw;


                span {
                    font-weight: 500;
                }

                p {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }

                .Heziyun-buttonArray {
                    gap: 3vw;

                    a {
                        min-width: 27vw;
                        padding: 2vw 5vw;
                        font-size: 3.5vw;

                        &:hover {
                            opacity: 0.75;
                        }
                    }
                }

                .Heziyun-suitableRegion {
                    color: #fff;
                    position: absolute;
                    bottom: 4vw;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 3.5vw;
                    width: 90%;
                    height: max-content;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: block;

                    img {
                        width: 5vw;
                    }
                }

                .Heziyun-recommendedServices {
                    width: 100%;
                    position: absolute;
                    bottom: 15vw;
                    left: 50%;
                    transform: translateX(-50%);
                    gap: 2vw;
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);

                    .Heziyun-item {
                        gap: 2vw;
                        padding: 1.5vw 3vw;

                        .Heziyun-title {

                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        .Heziyun-describe {}
                    }
                }
            }
        }

    }
}

// 产品优势
.Heziyun-advantage {
    background: url('../../static/img/theServer/intro_contact_block.webp') no-repeat center;
    background-size: cover;

    .Heziyun-defaultWidth {
        .Heziyun-content {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 3rem;

            .Heziyun-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 0.5rem;

                .Heziyun-titleImg {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 1rem;

                    img {
                        width: 1.7rem;
                    }
                }

                p {
                    color: #666666;
                    font-size: 0.75rem;
                    line-height: 1.7;
                }
            }
        }
    }
}

@media (max-width: 768px) {

    // 产品优势
    .Heziyun-advantage {

        .Heziyun-defaultWidth {
            .Heziyun-content {
                display: grid;
                grid-template-columns: repeat(1, 1fr);
                gap: 5vw;

                .Heziyun-item {
                    gap: 2vw;

                    .Heziyun-titleImg {
                        gap: 2vw;

                        img {
                            width: 8vw;
                        }
                    }

                    p {
                        font-size: 3.5vw;
                    }
                }
            }
        }
    }
}

// 产品功能
.Heziyun-function {
    background-color: #fff;

    .Heziyun-defaultWidth {
        .Heziyun-content {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 2rem;

            .Heziyun-item {
                background-color: #f2f6fa;
                position: relative;
                padding: 1.5rem 1.5rem 4rem;
                display: flex;
                flex-direction: column;
                gap: 1.5rem;

                &:hover {
                    &::after {
                        opacity: 1;
                        transition: all 0.3s ease;
                        -webkit-transition: all 0.3s ease;
                        -moz-transition: all 0.3s ease;
                        -ms-transition: all 0.3s ease;
                        -o-transition: all 0.3s ease;
                    }
                }

                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: url('../../static/img/theServer/web1.webp') no-repeat bottom right;
                    background-size: auto 6rem;
                    opacity: .4;
                    transition: all 0.3s ease;
                    -webkit-transition: all 0.3s ease;
                    -moz-transition: all 0.3s ease;
                    -ms-transition: all 0.3s ease;
                    -o-transition: all 0.3s ease;
                }

                .Heziyun-title {
                    font-size: 1.1rem;
                    color: #222;
                    line-height: 2rem;
                    font-weight: 600;
                    margin-bottom: 0.5rem;
                    position: relative;
                    z-index: 1;
                }

                .Heziyun-Qte {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                    position: relative;
                    z-index: 1;

                    span {
                        font-size: 0.9rem;
                        color: #222;
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;

                        img {
                            width: 1rem;
                        }
                    }

                    p {
                        opacity: .7;
                        color: #222;
                        font-size: 0.8rem;
                        line-height: 1.7;
                    }
                }
            }
        }
    }

}

@media (max-width: 768px) {

    // 产品功能
    .Heziyun-function {

        .Heziyun-defaultWidth {
            .Heziyun-content {
                grid-template-columns: repeat(1, 1fr);
                gap: 3vw;

                .Heziyun-item {
                    background-color: #f2f6fa;
                    position: relative;
                    padding: 4vw 4vw 7vw;
                    gap: 4vw;

                    &::after {
                        background-size: auto 28vw;
                    }

                    .Heziyun-title {
                        font-size: 5vw;
                        line-height: 1.7;
                        margin-bottom: 2vw;
                    }

                    .Heziyun-Qte {
                        gap: 2vw;

                        span {
                            font-size: 4vw;
                            color: #222;
                            display: flex;
                            align-items: center;
                            gap: 0.5rem;

                            img {
                                width: 5vw;
                            }
                        }

                        p {
                            font-size: 3.5vw;
                        }
                    }
                }
            }
        }

    }
}

// 应用场景
.Heziyun-applicationScenarios {
    background-color: rgb(29, 100, 250);

    .Heziyun-defaultWidth {
        .Heziyun-commodity-title {
            span {
                color: #fff;
            }
        }

        .Heziyun-content {
            width: 75rem;
            margin: 0 auto;
            position: relative;

            .swiper-container {
                width: 100%;
                overflow: hidden;

                .swiper-wrapper {

                    .swiper-slide {
                        padding: 1.5rem 1.5rem 4rem;
                        border-radius: 4px;
                        background: url('../../static/img/theServer/icon_card_quote_grey_ebce723.png') no-repeat bottom right;
                        background-size: auto 1rem;
                        background-position: 90% 90%;
                        background-color: #fff;

                        img {
                            width: 160px;
                            height: 80px;
                            display: block;
                            margin-bottom: 0.8rem;
                            object-fit: contain;
                        }

                        span {
                            color: #222;
                            display: block;
                            font-size: 1rem;
                            margin-bottom: 0.8rem;
                        }

                        p {
                            font-size: 0.75rem;
                            opacity: .9;
                            line-height: 1.7;
                            font-weight: 400;
                            text-align: justify;
                            -webkit-line-clamp: 4;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: normal;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                        }
                    }
                }


            }

            .swiper-button-next {
                border-radius: 50px;
                box-shadow: 0 6px 16px 2px rgba(7, 12, 20, .08);
                height: 2.5rem;
                width: 2.5rem;
                background: url('../../static/img/theServer/btn-arrow_131b1aa.png') no-repeat;
                background-size: auto 1.5rem;
                background-color: #fff;
                opacity: 1;
                position: absolute;
                top: 50%;
                right: -2%;
                transform: translateY(-50%);
                background-position: 61%;
                cursor: pointer;
                z-index: 3;

                &::after {
                    content: "";
                    display: none;
                }
            }

            .swiper-button-next.swiper-button-disabled {
                background-position: 106%;
            }

            .swiper-button-prev {
                border-radius: 50px;
                box-shadow: 0 6px 16px 2px rgba(7, 12, 20, .08);
                height: 2.5rem;
                width: 2.5rem;
                background: url('../../static/img/theServer/btn-arrow_131b1aa.png') no-repeat;
                background-size: auto 1.5rem;
                background-color: #fff;
                opacity: 1;
                position: absolute;
                top: 50%;
                left: -2%;
                transform: translateY(-50%);
                background-position: -7%;
                cursor: pointer;
                z-index: 3;

                &::after {
                    content: "";
                    display: none;
                }
            }


            .swiper-button-prev.swiper-button-disabled {
                background-position: 38%;
            }

        }
    }
}

@media (max-width: 768px) {

    // 应用场景
    .Heziyun-applicationScenarios {

        .Heziyun-defaultWidth {

            .Heziyun-content {
                width: 100%;

                .swiper-container {

                    .swiper-wrapper {

                        .swiper-slide {
                            padding: 5vw 5vw 7vw;
                            border-radius: 4px;
                            background: url('../../static/img/theServer/icon_card_quote_grey_ebce723.png') no-repeat bottom right;
                            background-size: auto 7vw;
                            background-position: 90% 90%;
                            background-color: #fff;

                            img {
                                width: 40vw;
                                height: 14vw;
                                margin-bottom: 4vw;
                            }

                            span {
                                font-size: 4.5vw;
                                margin-bottom: 3vw;
                            }

                            p {
                                font-size: 3.5vw;
                                -webkit-line-clamp: 3;
                            }
                        }
                    }


                }

                .swiper-button-next {
                    height: 10vw;
                    width: 10vw;
                    background-size: auto 5vw;
                    right: -5%;
                }

                .swiper-button-prev {
                    height: 10vw;
                    width: 10vw;
                    background-size: auto 5vw;
                    left: -5%;
                }

            }
        }
    }
}

// 客户之声
.Heziyun-custome {
    background-color: #fff;

    .partners-section {
        width: 100%;
        overflow: hidden;
        position: relative;
        mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
        display: flex;
        flex-direction: column;
        gap: 1.2rem;

        @keyframes animationOne {
            from {
                transform: translate(100%);
                -webkit-transform: translate(100%);
                -moz-transform: translate(100%);
                -ms-transform: translate(100%);
                -o-transform: translate(100%);
            }

            to {
                transform: translate(-100%);
                -webkit-transform: translate(-100%);
                -moz-transform: translate(-100%);
                -ms-transform: translate(-100%);
                -o-transform: translate(-100%);
            }
        }

        @keyframes animationTwos {
            from {
                transform: translate(0%);
                -webkit-transform: translate(0%);
                -moz-transform: translate(0%);
                -ms-transform: translate(0%);
                -o-transform: translate(0%);
            }

            to {
                transform: translate(-200%);
                -webkit-transform: translate(-200%);
                -moz-transform: translate(-200%);
                -ms-transform: translate(-200%);
                -o-transform: translate(-200%);
            }
        }

        .partners-track {
            display: flex;
            margin: 0 auto;
            transform: translateZ(0);
            backface-visibility: hidden;
            perspective: 1000px;
            will-change: transform;

            div {
                display: flex;
                white-space: nowrap;

                .Heziyun-item {

                    padding: 0.5rem 1rem;
                    margin: 0 1rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 10rem;
                    -webkit-border-radius: 10rem;
                    -moz-border-radius: 10rem;
                    -ms-border-radius: 10rem;
                    -o-border-radius: 10rem;
                }

                .Heziyun-item:nth-child(odd) {
                    background-color: rgb(232, 246, 254);
                }

                .Heziyun-item:nth-child(even) {
                    background-color: rgb(232, 238, 253);
                }
            }

            div:nth-child(1) {
                animation: animationOne var(--t) linear infinite;
                -webkit-animation: animationOne var(--t) linear infinite;
            }

            div:nth-child(2) {
                animation: animationTwos var(--t) linear infinite;
                -webkit-animation: animationTwos var(--t) linear infinite;
                animation-delay: calc(var(--t) / -2);
            }
        }
    }
}

@media (max-width: 768px) {

    // 客户之声
    .Heziyun-custome {

        .partners-section {
            gap: 4vw;

            .partners-track {

                div {

                    .Heziyun-item {
                        padding: 1vw 5vw;
                        margin: 0 2vw;
                        font-size: 3.5vw;
                    }
                }
            }
        }
    }
}

// 产品对比
.Heziyun-characteristics {
    position: relative;
    background-color: #fff;

    .Heziyun-defaultWidth {

        .Heziyun-melt {
            table {
                width: 100%;
                border-collapse: collapse;
                text-align: center;

                th,
                td {
                    border: 1px solid #E5E7EB;
                    padding: 1rem;
                }

                th {
                    background-color: #F3F4F6;
                    color: #111827;
                    font-weight: bold;
                    font-size: 1rem;

                    img {
                        width: 1.3rem;
                        height: 1.3rem;
                        object-fit: contain;
                        margin-right: 5px;
                    }
                }

                td {
                    color: #6B7280;
                }

                /* 为所有行的第三列添加边框 */
                tr td:nth-child(3),
                tr th:nth-child(3) {
                    border-left: 2px solid #2c6bff;
                    border-right: 2px solid #2c6bff;
                }

                // 最后一个tr中的td添加边框
                tr:last-child td:last-child {
                    border-bottom: 2px solid #2c6bff;
                }

                // 每偶数tr中的td添加背景
                tr:nth-child(even) td {
                    background-color: rgb(0 0 0 / 2%);
                }
            }
        }
    }
}

@media (max-width: 768px) {

    // 产品对比
    .Heziyun-characteristics {

        .Heziyun-grid {
            background-size: 3vw 3vw;
        }

        .Heziyun-defaultWidth {

            .Heziyun-melt {

                table {
                    width: 100%;
                    border-collapse: collapse;
                    text-align: center;

                    th,
                    td {
                        border: 1px solid #E5E7EB;
                        padding: 3vw 2vw;
                    }

                    th {
                        background-color: #F3F4F6;
                        color: #111827;
                        font-weight: bold;
                        font-size: 4vw;

                        img {
                            width: 5vw;
                            height: 5vw;
                        }
                    }

                    tr {
                        td {
                            font-size: 3.5vw;
                            line-height: 1.7;
                        }
                    }
                }
            }
        }
    }
}

// 快速入门
.Heziyun-quickStart {
    background-color: #fff;

    .Heziyun-defaultWidth {
        .Heziyun-content {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1rem;

            .Heziyun-item {
                padding: 1.2rem;
                border: 1px solid #c6cdd5;
                background: url('../../static/img/theServer/quick-start.png') no-repeat bottom right;
                background-size: auto 3rem;
                background-color: #f5f5f9;
                display: flex;
                gap: 0.5rem;
                cursor: pointer;

                &:hover {
                    .Heziyun-text {
                        span {
                            color: #006ee6;
                        }
                    }
                }

                .Heziyun-title {
                    font-family: "din";
                    color: #006ee6;
                    font-size: 2.2rem;
                    display: flex;
                    align-items: center;
                    height: max-content;
                    gap: 0.2rem;

                    i {
                        display: inline-block;
                        width: 0;
                        height: 0;
                        border-style: solid;
                        border-width: 0.5rem 0 0.5rem 0.5rem;
                        border-color: transparent transparent transparent #006ee6;
                    }
                }

                .Heziyun-text {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;

                    span {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        position: relative;
                        font-size: 1rem;
                        color: #333;
                        font-weight: 700;
                    }

                    p {
                        overflow: hidden;
                        color: #777;
                        font-size: 0.7rem;
                        color: #777;
                        line-height: 1.7;
                    }
                }
            }
        }
    }
}

@media (max-width: 768px) {

    // 快速入门
    .Heziyun-quickStart {

        .Heziyun-defaultWidth {
            .Heziyun-content {
                grid-template-columns: repeat(1, 1fr);
                gap: 3vw;

                .Heziyun-item {
                    padding: 3vw;
                    border: 1px solid #c6cdd5;
                    background: url('../../static/img/theServer/quick-start.png') no-repeat bottom right;
                    background-size: auto 3vw;
                    background-color: #f5f5f9;
                    display: flex;
                    gap: 2vw;
                    cursor: pointer;

                    .Heziyun-title {
                        font-size: 8vw;
                        gap: 2vw;

                        i {
                            border-width: 2vw 0 2vw 2vw;
                        }
                    }

                    .Heziyun-text {
                        gap: 2vw;

                        span {
                            font-size: 4.5vw;
                        }

                        p {
                            font-size: 3.5vw;
                        }
                    }
                }
            }
        }
    }
}
</style>